class CookieManager {
  static readonly DEFAULT_TIMEOUT_MS = 1500;
  static readonly CHECK_INTERVAL_MS = 100;

  readCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((c) => c.trim().startsWith(nameEQ));
    return cookie ? cookie.trim().substring(nameEQ.length) : null;
  }

  writeCookie(
    name: string,
    value: string,
    options?: {
      expires?: Date;
      path?: string;
      domain?: string;
      secure?: boolean;
      sameSite?: 'Lax' | 'Strict' | 'None';
    },
  ): void {
    let cookieString = `${name}=${value}`;

    if (options?.expires) {
      cookieString += `; expires=${options.expires.toUTCString()}`;
    }

    if (options?.path) {
      cookieString += `; path=${options.path}`;
    }
    if (options?.domain) {
      cookieString += `; domain=${options.domain}`;
    }
    if (options?.secure) {
      cookieString += `; secure`;
    }
    if (options?.sameSite) {
      cookieString += `; samesite=${options.sameSite}`;
    }

    document.cookie = cookieString;
  }

  async waitForCookie(cookieName: string, timeout: number = CookieManager.DEFAULT_TIMEOUT_MS): Promise<string | null> {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const checkCookie = (): void => {
        const cookieValue = this.readCookie(cookieName);
        if (cookieValue || Date.now() - startTime >= timeout) {
          clearInterval(interval);
          resolve(cookieValue || null);
        }
      };
      const interval = setInterval(checkCookie, CookieManager.CHECK_INTERVAL_MS);
    });
  }
}

const cookieManager = new CookieManager();
export { cookieManager };
